<template>
    <!--@formatter:off-->
    <div class="detail_list">
        <strong class="tit">{{$t('EnrolmentQuestionProgramCostEditor_title')}}</strong>
        <div class="cont">
            <ul class="list_detail">
                <li
                    v-for="(cost, index) in costs"
                    :key="`cost-${index}`"
                >
                    <span class="cost_inp">
                        <input
                            :id="`cost-${questionIndex}-${programIndex}-${index}`"
                            type="text"
                            :title="$t('EnrolmentQuestionProgramCostEditor_inputName')"
                            maxlength="10"
                            :value="cost.name"
                            @input="setValue({index, name: 'name', value: $event.target.value})"
                        >
                    </span>
                    <span class="cost_inp">
                        <TextInput
                            type="text"
                            :title="$t('EnrolmentQuestionProgramCostEditor_inputValue')"
                            placeholder="0"
                            :is-native-placeholder="true"
                            :only-number="true"
                            :maxlength="10"
                            :value="cost.value"
                            @input="setValue({index, name: 'value', value: $event})"
                        />
                    </span>
                    <span class="unit">{{$t('EnrolmentQuestionProgramCostEditor_unit')}}</span>
                    <button
                        v-show="costs.length > 1"
                        type="button"
                        class="btn_del"
                        @click="remove({index})"
                    >
                        <span class="blind">{{$t('EnrolmentQuestionProgramCostEditor_remove')}}</span>
                    </button>
                </li>
            </ul>

            <button
                v-show="isShowAdd"
                type="button"
                class="btn_add"
                @click="add"
                v-ga-helper:click="{
                    view_category: '수강신청프로그램',
                    view_area: '비용추가클릭',
                    view_label: '',
                }"
            >{{$t('EnrolmentQuestionProgramCostEditor_add')}}</button>

            <p class="noti">{{$t('EnrolmentQuestionProgramCostEditor_desc')}}</p>
        </div>
    </div>
    <!--@formatter:on-->
</template>

<script>
import TextInput from '@iamteacherpc/components/common/TextInput';
import {ADD_PROGRAM_COST, MAX_PROGRAM_COST, REMOVE_PROGRAM_COST} from '@common/store/modules/enrolment/editor';

export default {
    name: "EnrolmentQuestionProgramCostEditor",
    components: {TextInput},
    props: {
        questionIndex: {
            type: Number,
            required: true,
        },

        programIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        storePath() {
            return `form.questions.${this.questionIndex}.programs.${this.programIndex}`;
        },

        program() {
            return this.$store.getters['enrolment/getField'](this.storePath);
        },

        costs: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.storePath}.costs`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.storePath}.costs`,
                    value: newValue,
                });
            },
        },

        isShowAdd() {
            return this.costs.length < MAX_PROGRAM_COST;
        },
    },

    methods: {
        setValue({index, name, value}) {
            this.$store.commit('enrolment/updateField', {
                path: `${this.storePath}.costs.${index}.${name}`,
                value: value,
            });
        },

        remove({index}) {
            this.$store.dispatch(`enrolment/${REMOVE_PROGRAM_COST}`, {program: this.program, index});
        },

        add() {
            this.$store.dispatch(`enrolment/${ADD_PROGRAM_COST}`, {program: this.program});
          this.$emit('gaAddCost');
        },
    },
}
</script>

<style scoped>

</style>